import { businessSectors } from 'components/listForSelectingData/dataForLists';

export const getBusinessSectorDisplayName = (
  businessSectorNameBE: string
): string => {
  const sector = businessSectors.find(
    (s) => s.BEformat === businessSectorNameBE
  );

  return sector ? sector.displayName : businessSectorNameBE;
};
